import React from 'react';
import {useSelector} from 'react-redux';

import {COLUMNS} from '../../constants';
import {useGetAccountSearchResultCreditAlertsUsers} from '../../hooks/useGetAccountSearchResultCreditAlertsUsers';
import {accountSearchResultResultSelector} from '../../slices/account-search-result.slice';

import {HeaderCaption} from './header-caption';
import {HeaderSkeleton} from './header-skeleton';


type Props = {
    accountIds: number[],
    totalCount: number,
};

const CreditAlertsUsersHeaderController = ({accountIds, totalCount}: Props) => {
    const {isLoading, loadingError} = useGetAccountSearchResultCreditAlertsUsers({accountIds, totalCount});

    return (
        <HeaderCaption
            isLoading={isLoading}
            loadingError={loadingError}
            columnId={COLUMNS.CREDIT_ALERTS_ENABLED_USERS}
        />
    );
};

export const CreditAlertsUsersHeader = () => {
    const result = useSelector(accountSearchResultResultSelector);

    return result ? (
        <CreditAlertsUsersHeaderController
            accountIds={result.data.map(({accountId}) => accountId)}
            totalCount={result.totalCount}
        />
    ) : (
        <HeaderSkeleton columnId={COLUMNS.CRM_ENABLED_USERS}/>
    );
};
